{
  "journalAudit.action.dependency.removed": "Dépendance entre projets retirée",
  "v7.planification.backlog.aucun_choisi": "Choisissez un élément de tête dans la liste.",
  "v7.planification.backlog.cadrer": "Cadrer puis spécifier",
  "v7.planification.backlog.choisi": "Élément choisi",
  "v7.planification.backlog.description": "Description",
  "v7.planification.backlog.executant_disponible": "Service de traitement disponible.",
  "v7.planification.backlog.executant_indisponible": "Service de traitement indisponible : le traitement attendra son retour.",
  "v7.planification.backlog.executant_quoi": "l’état de l’exécutant",
  "v7.planification.backlog.flux_aucun": "Aucun traitement lancé depuis cet écran.",
  "v7.planification.backlog.flux_en_cours": "Traitement en cours.",
  "v7.planification.backlog.flux_en_echec": "Traitement en échec.",
  "v7.planification.backlog.flux_en_file": "Traitement en file d’attente.",
  "v7.planification.backlog.flux_erreur": "Le suivi du traitement est impossible pour le moment.",
  "v7.planification.backlog.flux_flux_coupe_reconnecter": "Le suivi a été interrompu avant la fin du traitement.",
  "v7.planification.backlog.flux_termine": "Traitement terminé.",
  "v7.planification.backlog.generer": "Générer le niveau suivant",
  "v7.planification.backlog.job_lance": "Traitement lancé : son suivi s’affiche ci-dessous.",
  "v7.planification.backlog.lancer": "Lancer un élément de tête",
  "v7.planification.backlog.liste": "Éléments de tête lancés",
  "v7.planification.backlog.liste_quoi": "les éléments de tête",
  "v7.planification.backlog.liste_vide": "Aucun élément de tête n’a encore été lancé.",
  "v7.planification.backlog.non_accessibles": "{{n}} élément(s) de projets qui ne vous sont pas ouverts : comptés sans détail.",
  "v7.planification.backlog.objectif_defini": "objectif défini",
  "v7.planification.backlog.objectif_non_defini": "objectif non défini",
  "v7.planification.backlog.ouvrir_fiche": "Ouvrir la fiche",
  "v7.planification.backlog.ouvrir_projet": "Ouvrir le projet cible",
  "v7.planification.backlog.produits_quoi": "les éléments produits",
  "v7.planification.backlog.produits_valeur": "{{total}} élément(s) produit(s) pour « {{titre}} ».",
  "v7.planification.backlog.produits_vide": "Aucun élément produit (un cadrage attend sa revue).",
  "v7.planification.backlog.projet_cible": "Projet cible",
  "v7.planification.backlog.reconnecter": "Reconnecter le suivi",
  "v7.planification.backlog.resultat_echec": "Le traitement a échoué : relancez-le après avoir vérifié le projet cible.",
  "v7.planification.backlog.resultat_termine": "Le traitement a produit son résultat.",
  "v7.planification.backlog.suivi": "Suivi du traitement",
  "v7.planification.backlog.titre": "Backlog du programme",
  "v7.planification.backlog.titre_champ": "Titre",
  "v7.planification.backlog.validation_projet": "Choisissez le projet cible.",
  "v7.planification.backlog.validation_titre": "Le titre doit comporter au moins 3 caractères.",
  "v7.planification.code.ACCESS_DENIED": "Vous n’êtes pas membre de ce programme.",
  "v7.planification.code.AI_STOPPED": "L’IA est arrêtée pour cette organisation : aucun traitement ne peut être lancé.",
  "v7.planification.code.ALREADY_EXISTS": "Cette dépendance est déjà déclarée.",
  "v7.planification.code.CONTEXTE_INCOMPLET": "Le contexte nécessaire à la vérification des droits est incomplet.",
  "v7.planification.code.DROIT_NON_TENU": "Vous ne tenez pas le droit requis pour ce geste.",
  "v7.planification.code.GARDE_DROIT_ABSENTE": "Cette opération ne déclare aucune garde de droits : elle est refusée.",
  "v7.planification.code.MISSING_PARAMETER": "Un paramètre obligatoire manque.",
  "v7.planification.code.NOT_FOUND": "Projet ou dépendance introuvable dans le programme.",
  "v7.planification.code.PROJECT_WRITE_REQUIRED": "Il faut un rôle d’écriture dans le projet cible.",
  "v7.planification.code.RESOURCE_UNAVAILABLE": "Cet objet n’existe pas dans le programme ou ne vous est pas accessible.",
  "v7.planification.code.SANS_SESSION": "Votre session a expiré : reconnectez-vous.",
  "v7.planification.code.VALIDATION_ERROR": "Un des projets n’appartient pas au programme, ou un champ est hors domaine.",
  "v7.planification.code.WORKSPACE_ARCHIVED": "Le projet consommateur est archivé : il est en lecture seule.",
  "v7.planification.dependances.artefact": "Artefact attendu",
  "v7.planification.dependances.aucune": "Choisissez une dépendance dans la liste.",
  "v7.planification.dependances.choisie": "Dépendance choisie",
  "v7.planification.dependances.choisir": "Voir",
  "v7.planification.dependances.confirmer_retrait": "Je confirme le retrait : {{consommateur}} n’attendra plus rien de {{fournisseur}} pour cet artefact.",
  "v7.planification.dependances.consommateur": "Projet consommateur",
  "v7.planification.dependances.declarer": "Déclarer une dépendance",
  "v7.planification.dependances.echeance": "Échéance proposée",
  "v7.planification.dependances.etat": "État",
  "v7.planification.dependances.etat_attendue": "attendue",
  "v7.planification.dependances.etat_bloquante": "bloquante",
  "v7.planification.dependances.etat_en_retard": "en retard",
  "v7.planification.dependances.etat_satisfaite": "satisfaite",
  "v7.planification.dependances.filtre_etat": "État",
  "v7.planification.dependances.filtre_projet": "Projet",
  "v7.planification.dependances.fournisseur": "Projet fournisseur",
  "v7.planification.dependances.ligne": "{{consommateur}} attend « {{artefact}} » de {{fournisseur}}",
  "v7.planification.dependances.liste": "Dépendances",
  "v7.planification.dependances.liste_quoi": "les dépendances",
  "v7.planification.dependances.retiree": "Dépendance retirée.",
  "v7.planification.dependances.retirer": "Retirer",
  "v7.planification.dependances.sans_echeance": "aucune échéance",
  "v7.planification.dependances.titre": "Dépendances entre projets du programme",
  "v7.planification.dependances.tous": "Tous",
  "v7.planification.dependances.vide": "Aucune dépendance entre les projets du programme.",
  "v7.planification.dependances.vide_filtre": "Aucune dépendance ne correspond au filtre.",
  "v7.planification.dialogue.annuler": "Annuler",
  "v7.planification.dialogue.artefact": "Artefact attendu",
  "v7.planification.dialogue.artefact_aide": "Fragment du chemin de l’artefact (3 à 300 caractères), par exemple contrat-api.md.",
  "v7.planification.dialogue.attendu": "Projet attendu (fournisseur)",
  "v7.planification.dialogue.aucun_projet": "Il faut au moins deux projets visibles dans le programme.",
  "v7.planification.dialogue.choisir": "Choisir…",
  "v7.planification.dialogue.consommateur": "Projet qui attend (consommateur)",
  "v7.planification.dialogue.declaree": "Dépendance déclarée.",
  "v7.planification.dialogue.declarer": "Déclarer la dépendance",
  "v7.planification.dialogue.projets_quoi": "les projets du programme",
  "v7.planification.dialogue.titre": "Déclarer une dépendance entre projets",
  "v7.planification.dialogue.validation_artefact": "L’artefact attendu doit comporter de 3 à 300 caractères.",
  "v7.planification.dialogue.validation_meme_projet": "Un projet ne peut pas dépendre de lui-même.",
  "v7.planification.dialogue.validation_projets": "Choisissez les deux projets.",
  "v7.planification.ecran_non_realise": "« {{ecran}} » mène à un écran qui n’est pas encore réalisé.",
  "v7.planification.element.avancement": "Avancement",
  "v7.planification.element.avancement_valeur": "{{faits}} / {{total}} terminés",
  "v7.planification.element.contribution_valeur": "{{faits}} / {{total}} éléments terminés",
  "v7.planification.element.contributions": "Contributions des projets",
  "v7.planification.element.contributions_non_visibles": "{{n}} contribution(s) d’un projet qui ne vous est pas visible : signalée(s) sans détail.",
  "v7.planification.element.contributions_quoi": "les contributions",
  "v7.planification.element.definir_objectif": "Définir l’objectif",
  "v7.planification.element.dependances": "Dépendances",
  "v7.planification.element.generer_enfants": "Générer les éléments enfants",
  "v7.planification.element.geste_non_raccorde": "« {{geste}} » n’a pas encore d’opération : lancez-le depuis le backlog du programme.",
  "v7.planification.element.lien_dependances": "Dépendances du programme",
  "v7.planification.element.niveau": "Niveau",
  "v7.planification.element.objectif": "Objectif",
  "v7.planification.element.panneau": "Élément de tête",
  "v7.planification.element.preparer_document": "Préparer le document",
  "v7.planification.element.quoi": "l’élément",
  "v7.planification.element.retour": "Retour aux éléments du programme",
  "v7.planification.element.sans_contribution": "Aucun projet ne contribue encore.",
  "v7.planification.element.sans_dependance": "Aucune dépendance entre ses projets.",
  "v7.planification.element.sans_element": "Aucun élément n’est désigné : ouvrez cette fiche depuis le backlog du programme.",
  "v7.planification.element.sans_objectif": "Aucun objectif défini.",
  "v7.planification.element.titre": "Élément du programme",
  "v7.planification.element.titre_champ": "Titre",
  "v7.planification.etat.chargement": "Chargement de {{quoi}}…",
  "v7.planification.etat.en_cours": "Envoi en cours…",
  "v7.planification.etat.erreur": "{{quoi}} : lecture impossible pour le moment.",
  "v7.planification.etat.introuvable": "{{quoi}} : introuvable dans ce programme.",
  "v7.planification.etat.reessayer": "Réessayer",
  "v7.planification.etat.refus": "{{quoi}} : vous n’avez pas accès à cette information.",
  "v7.planification.geste.erreur": "Le geste n’a pas abouti. Réessayez dans un instant.",
  "v7.planification.projets_non_visibles": "{{n}} projet(s) du programme ne vous sont pas visibles : comptés sans détail.",
  "v7.planification.sans_programme": "Aucun programme n’est choisi : choisissez-en un dans le sélecteur de contexte.",
  "v7.planification.vue.ensemble": "Vue d’ensemble",
  "v7.planification.vue.ensemble_quoi": "la vue du programme",
  "v7.planification.vue.membres": "Membres du programme",
  "v7.planification.vue.membres_quoi": "les membres",
  "v7.planification.vue.membres_vide": "Aucun membre.",
  "v7.planification.vue.nom": "Programme",
  "v7.planification.vue.objectif": "Objectif",
  "v7.planification.vue.objectif_registre": "Objectif et registre des risques",
  "v7.planification.vue.par_element": "Avancement par élément de tête",
  "v7.planification.vue.par_element_quoi": "l’avancement par élément",
  "v7.planification.vue.par_element_vide": "Aucun élément de tête dans les projets ouverts.",
  "v7.planification.vue.par_projet": "Avancement par projet",
  "v7.planification.vue.par_projet_quoi": "l’avancement des projets",
  "v7.planification.vue.par_projet_vide": "Aucun projet rattaché au programme.",
  "v7.planification.vue.projet_valeur": "{{faits}} / {{total}} éléments terminés",
  "v7.planification.vue.projets": "Projets",
  "v7.planification.vue.sans_objectif": "Aucun objectif défini.",
  "v7.planification.vue.sans_version": "aucune version en préparation",
  "v7.planification.vue.sante": "Santé la plus basse",
  "v7.planification.vue.titre": "Vue programme",
  "v7.planification.vue.train": "Train du programme",
  "v7.planification.vue.train_quoi": "le train",
  "v7.planification.vue.train_vide": "Aucun projet dans le train."
}
